interface IIosWindow {
	webkit: {
		messageHandlers: {
			accessToken: {
				postMessage(options: { callback: 'onGetIOSTokenHandler'; identifier: string }): void;
			};
		};
	};
	onGetIOSTokenHandler: (token: string, identifier: string) => void;
}

const win = (window as any) as IIosWindow;
let requestsChainIt = 0;
const requestsChain: { [key: string]: (token: string) => void } = {};

win.onGetIOSTokenHandler = (token, identifier) => {
	requestsChain[identifier](token);
	delete requestsChain[identifier];
};

export function getAuthTokenIos(onRecieveToken: (token: string) => void) {
	requestsChainIt += 1;
	requestsChain[requestsChainIt] = onRecieveToken;
	// use the identifier for make sure the correct callback is executed
	win.webkit.messageHandlers.accessToken.postMessage({
		callback: 'onGetIOSTokenHandler',
		identifier: requestsChainIt.toString(),
	});
}
